{
    "ServerStatus_heading_applicationProperties": "Propriedades do aplicativo",
    "ServerStatus_action_refresh": "Atualizar status",
    "NAME": "Idioma do status do servidor"
}